import { auth } from "firebase";
import { db } from "../services/Firebase";
import { getUserById } from "./users";

export const signup = async (email, password, username) => {
    let result = { success: true, error: null };

    await auth().createUserWithEmailAndPassword(email, password)
        .then(async (user) => {
            await db.collection('Users')
                .doc(user.user.uid)
                .set({
                    email: email,
                    username: username,
                    courses: [],
                    paths: [],
                    badges: [],
                    grade: "",
                    notifications: [],
                    date: (new Date()).toString()
                })
                .then(async () => {
                    let currentUser = await getUserById(user.user.uid);
                    localStorage.setItem('currentUser', JSON.stringify(currentUser));
                    result = { success: true, user: user };
                })
                .catch(reason => {
                    result = { success: false, error: { code: "register-error", message: "Erreur lors de l'enregistrement !" } };
                })
        })
        .catch(reason => {
            result = { success: false, error: reason };
        })

    return result;
}

export const signin = async (email, password) => {
    let result = { success: true, error: null };

    await auth().signInWithEmailAndPassword(email, password)
        .then(async (user) => {
            let currentUser = await getUserById(user.user.uid);
            console.log("current user : ", currentUser);
            localStorage.setItem('currentUser', JSON.stringify(currentUser));
        })
        .catch(reason => {
            result = { success: false, error: reason };
        })

    return result;
}

export const signout = () => {
    return auth().signOut();
}